module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about-outer"
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_3",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "310.29px",
      "height": "48.58px",
      "viewBox": "0 0 310.29 48.58",
      "enable-background": "new 0 0 310.29 48.58",
      "xml:space": "preserve"
    }
  }, [_c('g', {
    staticClass: "lines"
  }, [_c('path', {
    staticClass: "about-path",
    attrs: {
      "d": "M46.574,45.993c0,0,0.338,0.911-0.737,0.911H35.132c-0.275,0-0.502-0.18-0.562-0.43l-2-8.314H16.852l-4.144,8.309\n    \t\tc-0.129,0.258-0.406,0.436-0.682,0.436H1.322c0,0-1.027,0.086-0.492-0.91l23.505-43.72c0.136-0.254,0.42-0.415,0.67-0.415h9.221\n    \t\tc0.274,0,0.496,0.184,0.558,0.414L46.574,45.993z M25.274,3.184L2.481,45.579h9.26l4.144-8.308\n    \t\tc0.129-0.259,0.406-0.436,0.682-0.436h16.64c0.267,0,0.5,0.172,0.562,0.429l2,8.314h9.263L33.601,3.184H25.274z M30.819,29.416\n    \t\th-9.857c-1.057,0-0.497-0.899-0.497-0.899l6.595-12.718c0.622-1.199,1.236-0.006,1.236-0.006l3.262,12.719\n    \t\tC31.812,29.503,30.819,29.416,30.819,29.416z M27.405,17.869l-5.301,10.223h7.923L27.405,17.869z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "about-path",
    attrs: {
      "d": "M85.644,33.947c-1.161,8.582-8.684,12.957-17.412,12.957H51.804c-0.401,0-0.611-0.379-0.573-0.662l5.882-43.508\n    \t\tc0.054-0.401,0.468-0.663,0.752-0.663h16.428c8.803,0,13.603,4.63,12.456,13.116c-0.483,3.57-2.098,6.586-4.439,8.775\n    \t\tC84.95,26.297,86.224,29.656,85.644,33.947z M80.901,23.553c2.406-1.988,4.043-4.816,4.523-8.365\n    \t\tc1.045-7.73-3.049-11.791-11.31-11.791H58.349l-5.703,42.183h15.766c8.336,0,14.875-3.999,15.907-11.632\n    \t\tc0.567-4.193-0.802-7.31-3.483-9.366C80.267,24.146,80.761,23.668,80.901,23.553z M64.902,27.244h1.272\n    \t\tc1.988,0,9.705,0.141,8.904,6.066c-0.79,5.845-6.716,6.068-10.545,6.068h-1.272c-0.284,0-0.627-0.262-0.573-0.662l1.462-10.811\n    \t\tC64.188,27.621,64.501,27.244,64.902,27.244z M64.103,38.055h0.609c4.12,0,8.441-0.307,9.041-4.744\n    \t\tc0.589-4.354-5.401-4.742-7.758-4.742h-0.609L64.103,38.055z M65.053,21.229l1.461-10.811c0.039-0.284,0.351-0.662,0.752-0.662\n    \t\th1.272c3.916,0,8.248,0.338,7.473,6.067s-5.198,6.067-9.114,6.067h-1.272C65.341,21.891,64.999,21.629,65.053,21.229z\n    \t\t M67.077,20.566c4.033,0,6.995-0.192,7.61-4.743s-2.294-4.743-6.328-4.743H67.75l-1.283,9.486H67.077z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "about-path",
    attrs: {
      "d": "M118.206,1.064c12.683,0,21.215,10.652,19.506,23.291c-1.708,12.637-13.126,23.344-25.811,23.344\n    \t\tc-12.683,0-21.26-10.704-19.551-23.344C94.059,11.714,105.525,1.064,118.206,1.064z M112.08,46.374\n    \t\tc11.905,0,22.691-10.067,24.307-22.019c1.616-11.95-6.454-21.967-18.36-21.967c-11.908,0-22.738,10.019-24.353,21.967\n    \t\tC92.059,36.305,100.174,46.374,112.08,46.374z M116.831,11.239c7.171,0,11.935,5.99,10.972,13.116\n    \t\tc-0.963,7.123-7.35,13.169-14.525,13.169c-7.173,0-11.981-6.042-11.018-13.169C103.223,17.226,109.662,11.239,116.831,11.239z\n    \t\t M113.456,36.199c6.391,0,12.15-5.4,13.021-11.844c0.871-6.441-3.431-11.791-9.826-11.791c-6.397,0-12.197,5.354-13.067,11.791\n    \t\tC102.713,30.795,107.062,36.199,113.456,36.199z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "about-path",
    attrs: {
      "d": "M177.901,30.715c-1.508,11.153-8.605,16.984-20.023,16.984s-16.938-5.831-15.43-16.984l3.812-28.193\n    \t\tc0.054-0.4,0.468-0.662,0.752-0.662h9.963c0.401,0,0.611,0.378,0.573,0.662L154.13,27.8c-0.965,7.134,0.759,8.771,5.252,8.771\n    \t\tc4.495,0,6.66-1.637,7.625-8.771l3.417-25.278c0.054-0.4,0.468-0.662,0.752-0.662h9.963c0.401,0,0.611,0.378,0.573,0.662\n    \t\tL177.901,30.715z M171.661,3.184L168.333,27.8c-1.013,7.493-3.872,10.095-9.128,10.095c-5.257,0-7.412-2.603-6.399-10.095\n    \t\tl3.328-24.616h-8.638l-3.722,27.531c-1.416,10.467,3.444,15.659,14.284,15.659c10.839,0,17.104-5.192,18.519-15.659l3.723-27.531\n    \t\tH171.661z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "about-path",
    attrs: {
      "d": "M186.831,2.521c0.055-0.4,0.468-0.662,0.752-0.662h30.736c0.401,0,0.611,0.378,0.573,0.662l-1.182,8.744\n    \t\tc-0.054,0.401-0.468,0.662-0.752,0.662h-9.725l-4.639,34.314c-0.054,0.4-0.468,0.662-0.752,0.662h-9.963\n    \t\tc-0.401,0-0.611-0.379-0.573-0.662l4.639-34.314h-9.724c-0.401,0-0.611-0.377-0.573-0.662L186.831,2.521z M196.788,10.604\n    \t\tc0.284,0,0.627,0.262,0.573,0.662l-4.64,34.313h8.638l4.639-34.313c0.039-0.284,0.351-0.662,0.752-0.662h9.725l1.003-7.42h-29.412\n    \t\tl-1.003,7.42H196.788z"
    }
  })])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about-container"
  }, [_c('div', {
    staticClass: "lefty"
  }, [_c('p', [_vm._v("\n          Born and raised in Sydney, Australia, I'm a web developer with a passion\n          for intuitive design and front-end development.\n          "), _c('br'), _c('br'), _vm._v("\n          Outside of work I love listening to podcasts from RadioLab, This\n          American Life and Syntax as well as riding my motorbike around the\n          streets of Sydney.\n          "), _c('br'), _c('br'), _vm._v("\n          My background is in the fast-paced agency world as a\n          developer and project manager. I've also worked as a teachers\n          assistant for General Assembly's Front End Web Development course, and as\n\t\t\t\t\ta freelance developer.\n          "), _c('br'), _c('br'), _vm._v("\n          I'm at my best when I'm working on the front-end, but I'm also\n          comfortable working with Ruby on Rails, PHP/Laravel as well as\n          PHP/Wordpress. I absolutely love working with VueJS. It's my go to\n          framework for the bulk of my professional projects as well as personal\n          ones.\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "righty"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "id": "myCanvasContainer"
    }
  }, [_c('canvas', {
    staticStyle: {
      "width": "100% !important"
    },
    attrs: {
      "width": "500",
      "height": "400",
      "id": "myCanvas"
    }
  }, [_c('ul', [_c('li', [_c('a', {
    staticClass: "skill",
    attrs: {
      "target": "_blank",
      "aria-hidden": "”false"
    }
  }, [_vm._v("HTML/CSS:"), _c('br'), _vm._v(" Less, Sass")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "skill",
    attrs: {
      "target": "_blank",
      "aria-hidden": "”false"
    }
  }, [_vm._v("Javascript: "), _c('br'), _vm._v("Vanilla JS, "), _c('br'), _vm._v("ES6, JQuery")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "skill",
    attrs: {
      "target": "_blank",
      "aria-hidden": "”false"
    }
  }, [_vm._v("VueJS:"), _c('br'), _vm._v(" Vue Router, Vuex")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "skill",
    attrs: {
      "target": "_blank",
      "aria-hidden": "”false"
    }
  }, [_vm._v("Firebase Suite")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "skill",
    attrs: {
      "target": "_blank",
      "aria-hidden": "”false"
    }
  }, [_vm._v("Wordpress")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "skill",
    attrs: {
      "target": "_blank",
      "aria-hidden": "”false"
    }
  }, [_vm._v("Photoshop")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "skill",
    attrs: {
      "target": "_blank",
      "aria-hidden": "”false"
    }
  }, [_vm._v("Ruby on Rails")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "skill",
    attrs: {
      "target": "_blank",
      "aria-hidden": "”false"
    }
  }, [_vm._v("Git")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "skill",
    attrs: {
      "target": "_blank",
      "aria-hidden": "”false"
    }
  }, [_vm._v("Yarn")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "skill",
    attrs: {
      "target": "_blank",
      "aria-hidden": "”false"
    }
  }, [_vm._v("NPM")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "skill",
    attrs: {
      "target": "_blank",
      "aria-hidden": "”false"
    }
  }, [_vm._v("MAMP")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "skill",
    attrs: {
      "target": "_blank",
      "aria-hidden": "”false"
    }
  }, [_vm._v("RESTful APIs")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "skill",
    attrs: {
      "target": "_blank",
      "aria-hidden": "”false"
    }
  }, [_vm._v("Sketch")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "skill",
    attrs: {
      "target": "_blank",
      "aria-hidden": "”false"
    }
  }, [_vm._v("Webpack")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57668661"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/About.vue
// module id = 49
// module chunks = 0